import React from "react";
import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";

import "./ArticleCard.scss";


function toText(node) {
    let tag = document.createElement("div");
    tag.innerHTML = node;
    node = tag.innerText;
    return node;
}

function shortenText(text, startingPoint, maxLength) {
    return text.length > maxLength
        ? text.slice(startingPoint, maxLength)
        : text;
}

export default function ArticleCard(props) {
    return(
        <Card className="card-main pt-2 pb-2 col-xl-2 col-lg-3 col-md-4 col-sm-5 d-flex flex-column">
            <div className="tag-row d-inline-block justify-content-between">
                {props.categories.map((tagItem) => <div key={tagItem} className="tags col badge badge-primary">{tagItem}</div>)}
            </div>
            <Card.Img className="card-img" variant="top" src={props.imageUrl} />
            <div className="card-body d-flex flex-column justify-content-center p-1">
                <div className="card-title text-center title" >{props.title}</div>
                <div className="card-text desc">{toText(props.description)}</div>
            </div>
            <div className="card-footer p-1 d-flex flex-column justify-content-center">
                <a href={props.link} target='_blank' rel="noopener noreferrer" className="align-self-center"><Button  variant="primary">Read more</Button></a>
            </div>
        </Card>
    );
}